import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import History from 'project/components/collaborator_history';
import { closeCollaboratorHistory } from 'project/ducks/collaborators';

export function mapStateToProps({ project: { collaborators } }) {
  return {
    ...collaborators.data,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    toggle: closeCollaboratorHistory,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(History);



// WEBPACK FOOTER //
// ./project/containers/collaborator_history.js